// import _ from 'lodash';
import React from 'react'
import PropTypes from 'prop-types'
import { Card } from 'semantic-ui-react'

import JobCounterWidget from './dashboard/JobCounter'
import JobsLast10Widget from './dashboard/JobLast10'
import MinionCounterWidget from './dashboard/MinionCounter'
import MinionKeysWidget from './dashboard/MinionKeys'

const Dashboard = (props) => {
  // console.log('Dashboard', props)
  return (
    <div>
      <Card.Group itemsPerRow={3} stackable textAlign={'center'}>
        <MinionCounterWidget {...props}/>

        <MinionKeysWidget {...props}/>

        <JobCounterWidget {...props}/>
      </Card.Group>
      <JobsLast10Widget {...props}/>
    </div>
  )
}
Dashboard.displayName = 'Dashboard'
Dashboard.propTypes = {
  minions: PropTypes.object,
  accepted: PropTypes.number,
  pending: PropTypes.number,
  refused: PropTypes.number,
  jobs: PropTypes.object
}
export default Dashboard



// WEBPACK FOOTER //
// ./src/components/Dashboard.js